import * as types from '../../constants/log/nicknameTransactionLogConstants';

export const nicknameChangeLogListRequest = ({
  page,
  pageLength,
  beginDate,
  endDate,
  account,
  callback,
  error,
}) => ({
  type: types.NICKNAME_LOG_LIST_REQUEST,
  page,
  pageLength,
  beginDate,
  endDate,
  account,
  callback,
  error,
});
